import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { memo } from 'react';

import { useRawSnapshotSpec } from '@flipster/features/src/shared/snapshot/use-snapshot-spec';
import { FormattedMessage } from '@flipster/i18n';
import { Styles, css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import { communityFeedBunja } from '../../bunja';
import { RollingBanner } from './banner';
import { LivePnlShoutoutCard } from './card';

export const LivePnlShoutout = ({ css: cssProps }: { css?: Styles }) => {
  const { symbolLivePnlAtom } = useBunja(communityFeedBunja);
  const symbolLivePnl = useAtomValue(symbolLivePnlAtom);
  if (!symbolLivePnl || symbolLivePnl.pnls.length == 0) return;
  return (
    <div className={css(stack.raw({ gap: 16 }), cssProps)}>
      <LivePnlShoutoutImpl />
    </div>
  );
};

const LivePnlShoutoutImpl = memo(() => {
  const { symbolLivePnlAtom } = useBunja(communityFeedBunja);
  const symbolLivePnl = useAtomValue(symbolLivePnlAtom);
  const { instrumentsKeyBySymbol } = useRawSnapshotSpec();
  if (!symbolLivePnl || symbolLivePnl.pnls.length == 0) return;
  return (
    <>
      <p className={css({ textStyle: 'Text/L/Strong', color: 'content.default.level-5' })}>
        <FormattedMessage
          id='Autogen_common.r251126.s_value_Live_PnL'
          values={{
            value: instrumentsKeyBySymbol?.[symbolLivePnl.symbol].displayShortName,
          }}
        />
      </p>
      {symbolLivePnl.pnls.length === 1 ? (
        <LivePnlShoutoutCard item={symbolLivePnl.pnls[0]} />
      ) : (
        <RollingBanner count={2}>
          {symbolLivePnl.pnls.map((item) => (
            <LivePnlShoutoutCard key={item.id} item={item} />
          ))}
        </RollingBanner>
      )}
    </>
  );
});
